module.exports = __webpack_public_path__ + "static/media/map-icon-green.5f06be33.svg";